import PurchaseOrdersPage from '@components/containers/purchaseOrder';
import AppLayout from '@layouts/AppLayout';
import useAiAnalystContext from '@providers/AiAnalyst/useAiAnalystContext';
import { useEffect, type FC } from 'react';

const PurchaseOrders: FC = () => {
    const { setShowAISidebar } = useAiAnalystContext(
        (context) => context.actions,
    );
    const { showAISideBar } = useAiAnalystContext((context) => context.state);
    useEffect(() => {
        if (showAISideBar) {
            setShowAISidebar(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppLayout>
            <PurchaseOrdersPage />
        </AppLayout>
    );
};

export default PurchaseOrders;
